import React from 'react';
import styled from 'styled-components';
import { IconProps } from '../../../interfaces';

const StyledSVG = styled.svg`
  flex-shrink: 0;
`;

const FinancialGuideIcon: React.FC<IconProps> = (props) => {
  return (
    <StyledSVG
      xmlns='http://www.w3.org/2000/svg'
      width={props.width ? props.width : '24px'}
      height={props.height ? props.height : '22px'}
      viewBox='0 0 24 22'
      version='1.1'
      aria-hidden='true'
    >
      <g
        xmlns='http://www.w3.org/2000/svg'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          transform='translate(-513.000000, -367.000000)'
          fill='#650360'
          fillRule='nonzero'
        >
          <g transform='translate(484.000000, 236.000000)'>
            <g transform='translate(29.988281, 131.027344)'>
              <path d='M5.96484375,11.9179688 C9.1875,11.9179688 11.9179688,9.2109375 11.9179688,5.953125 C11.9179688,2.6953125 9.22265625,0 5.96484375,0 C2.6953125,0 0.01171875,2.6953125 0.01171875,5.953125 C0.01171875,9.234375 2.6953125,11.9179688 5.96484375,11.9179688 Z M14.6953125,3.65625 L22.7109375,3.65625 C23.203125,3.65625 23.6132812,3.26953125 23.6132812,2.765625 C23.6132812,2.2734375 23.203125,1.88671875 22.7109375,1.88671875 L14.6953125,1.88671875 C14.203125,1.88671875 13.8164062,2.2734375 13.8164062,2.765625 C13.8164062,3.26953125 14.203125,3.65625 14.6953125,3.65625 Z M5.25,9.46875 C5.0625,9.46875 4.81640625,9.38671875 4.6640625,9.22265625 L2.4140625,6.75 C2.33203125,6.65625 2.2734375,6.4453125 2.2734375,6.28125 C2.2734375,5.859375 2.6015625,5.54296875 3,5.54296875 C3.2578125,5.54296875 3.43359375,5.66015625 3.5625,5.7890625 L5.2265625,7.58203125 L8.30859375,3.29296875 C8.44921875,3.10546875 8.66015625,2.9765625 8.9296875,2.9765625 C9.31640625,2.9765625 9.66796875,3.28125 9.66796875,3.703125 C9.66796875,3.83203125 9.609375,3.984375 9.50390625,4.13671875 L5.87109375,9.1875 C5.7421875,9.36328125 5.5078125,9.46875 5.25,9.46875 Z M14.6953125,9.796875 L22.7109375,9.796875 C23.203125,9.796875 23.6132812,9.41015625 23.6132812,8.90625 C23.6132812,8.4140625 23.203125,8.02734375 22.7109375,8.02734375 L14.6953125,8.02734375 C14.203125,8.02734375 13.8164062,8.4140625 13.8164062,8.90625 C13.8164062,9.41015625 14.203125,9.796875 14.6953125,9.796875 Z M0.87890625,15.9375 L22.7109375,15.9375 C23.203125,15.9375 23.6132812,15.5390625 23.6132812,15.046875 C23.6132812,14.5546875 23.203125,14.1679688 22.7109375,14.1679688 L0.87890625,14.1679688 C0.38671875,14.1679688 0,14.5546875 0,15.046875 C0,15.5390625 0.38671875,15.9375 0.87890625,15.9375 Z M0.87890625,22.0664062 L22.7109375,22.0664062 C23.203125,22.0664062 23.6132812,21.6796875 23.6132812,21.1875 C23.6132812,20.6953125 23.203125,20.296875 22.7109375,20.296875 L0.87890625,20.296875 C0.38671875,20.296875 0,20.6953125 0,21.1875 C0,21.6796875 0.38671875,22.0664062 0.87890625,22.0664062 Z' />
            </g>
          </g>
        </g>
      </g>
    </StyledSVG>
  );
};

export default FinancialGuideIcon;
